/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import logo from "../assets/images/logo.png";
import { Fade } from "react-reveal";
import "./About.css";

export default function About() {
  return (
    <div>
      <div className="bgColor container-fluid" id="about">
        <div className="aboutCard">
          <img className="aboutLogo" src={logo} alt="logo" />

          <Fade bottom>
            <h3>عن فاليو اكسبرت عُمان</h3>
            <p>
              فاليو اكسبرت ﻫﻲ ﺑﺼﻤﺔ اﻟﻨﺠﺎح اﻟﺘﻲ اﻣﺘﺪت ﻣﻦ اﻟﺴﻌﻮدﻳﺔ إﻟﻰ سلطنة عمان،
              ﺑﺼﻔﺘﻬﺎ ﻧﻤﻮذج ﻋﺼﺮي واﺳﺘﺜﻨﺎﺋﻲ ﻓﻲ ﺗﻘﺪﻳﻢ أﻧﺸﻄﺔ اﻟﺘﻘﻴﻴﻢ اﻟﻌﻘﺎري؛ ﻟﺘﻐﺬي
              اﺣﺘﻴﺎﺟﺎت اﻟﺴﻮق اﻟﻌﻤﺎﻧﻲ ﻟﻜﺎﻓﺔ اﻟﺨﺪﻣﺎت ذات اﻟﺼﻠﺔ وﻓﻖ ﻣﻌﺎﻳﻴﺮ دوﻟﻴﺔ
              وﻣﻨﻬﺞ ﻋﻠﻤﻲ دﻗﻴﻖ. ﺑﺪأت فاليو اكسبرت ﻓﻲ اﻟﺴﻌﻮدﻳﺔ ﻋﺎم ٢٠١٥ ﻛﺠﻬﺔ
              ﻣﻌﺘﻤﺪة ﻟﻤﺰاوﻟﺔ اﻟﺘﻘﻴﻴﻢ اﻟﻌﻘﺎري ﻣﻦ ﻗﺒﻞ اﻟﻬﻴﺌﺔ اﻟﺴﻌﻮدﻳﺔ ﻟﻠﻤﻘﻴﻤﻴﻦ
              واﺳﺘﻄﺎﻋﺖ اﻟﺘﻮﺳﻊ ﺳﺮﻳﻌًﺎ ﻓﻲ ﻣﻨﺎﻃﻖ اﻟﻤﻤﻠﻜﺔ ﺑﻔﻀﻞ ﻛﺎدرﻫﺎ اﻟﺒﺸﺮي اﻟﻤﺪرّب
              وﺗﺤﺎﻟﻔﺎﺗﻬﺎ اﻟﺪوﻟﻴﺔ ﻣﻊ ﺷﺮﻛﺎت اﻟﺘﻘﻴﻴﻢ اﻟﻌﻘﺎري ﻓﻲ اﻟﻌﺎﻟﻢ، وﺑﺪأت ﺗﺰاول
              ﻧﺸﺎﻃﺎﺗﻬﺎ ﻓﻲ ﻋﻤﺎن ﺑﺸﺮاﻛﺔ وﺛﻴﻘﺔ ﻣﻊ ﺷﺮﻛﺔ أﺳﺎور اﻟﻌﻘﺎرﻳﺔ ﺑﻤﺎ ﻳﺨﺪم
              ﻣﺼﺎﻟﺢ اﻟﺴﻠﻄﻨﺔ ﻟﺘﺤﻘﻴﻖ رؤﻳﺔ ﻋﻤﺎن٢٠٤٠.
            </p>
          </Fade>
        </div>
      </div>
    </div>
  );
}
